// Veri sorumlusu kimliği — TÜM yasal metinler (KVKK, gizlilik, çerez, kullanım koşulları,
// ticari ileti, açık rıza, CRM sözleşmesi) bu değerleri {{anahtar}} yer tutucularıyla kullanır.
// Köşeli parantezli değerler DOLDURULMASI GEREKEN alanlardır (TODO). Sayfalarda vurgulu görünürler.
// Aynı değerler mobilde: OdazenMobilNew/src/constants/legal.ts — ikisini birlikte güncelleyin.

export const LEGAL = {
  brand: 'Odazen',
  companyTitle: 'CODECRAFTOPİA YAZILIM VE DANIŞMANLIK LİMİTED ŞİRKETİ',
  mersisNo: '0211152919300001',
  tradeRegistryNo: '1089086',
  taxOffice: 'Üsküdar Vergi Dairesi Müdürlüğü',
  taxNo: '2111529193',
  address: '[Şirket adresi]', // TODO: tebligata esas açık adres
  kepAddress: '[KEP adresi]', // TODO: ör. unvan@hs01.kep.tr
  kvkkEmail: 'destek@odazen.com', // TODO: ayrı bir kvkk@ kutusu açılırsa değiştirin
  supportEmail: 'destek@odazen.com',
  phone: '[Telefon]', // TODO: boş bırakılırsa ('') satır gizlenir
  verbisNo: '[VERBİS kayıt no]', // TODO: VERBİS kayıt yükümlülüğü yoksa '' yapın (satır gizlenir)
  website: 'https://odazen.com',
  // CRM Veri İşleme Eki — alt işleyenler
  hostingProvider: '[Barındırma sağlayıcısı]', // TODO: VPS sağlayıcısının unvanı
  hostingLocation: '[Sunucu konumu (ülke/şehir)]', // TODO
  smtpProvider: '[E-posta (SMTP) sağlayıcısı]', // TODO: mail.codecraftopia.com sunucusunu işleten taraf
  smtpLocation: '[E-posta sunucusu konumu]', // TODO
  smsProvider: '[SMS sağlayıcısı]', // TODO: TopluSMS/VatanSMS API'sini sağlayan şirketin unvanı
  // 21.10.2026 — KYC (otomatik ön kontrol, biyometrik yüz karşılaştırması) için güncellenen metinler
  // AVUKAT İNCELEMESİ GEREKLİ: legal.kvkk (2, 3, yeni 4. "kimlik-dogrulama" ve 7. "saklama" bölümleri),
  // legal.explicitConsent (yeni 4. "biyometrik") ve privacy ("Kimlik doğrulama" maddesi). tr/en.json'da ilgili
  // bölümler "_review" alanıyla işaretli (sayfada gösterilmez). Mobil kopya: OdazenMobilNew/src/constants/legalTexts.ts
  // 21.10.2026 — Mülk Takibi (ev sahibi aracı) için güncellenen metinler — AVUKAT İNCELEMESİ GEREKLİ:
  // legal.kvkk (yeni 5. "mulk-takibi" bölümü; 2, 3, 6 ve 8. bölümlere eklenen satır/maddeler; sonraki bölümler yeniden
  // numaralandı), terms (yeni 9. "mulk-takibi" bölümü ve 3. "hizmet" bölümüne paragraf; sonraki bölümler yeniden
  // numaralandı) ve privacy ("kapsam" paragrafı, "toplanan" maddesi). Kiracı verisinde veri sorumlusu ev sahibi,
  // Odazen veri işleyendir. tr/en.json'da "_review" alanıyla işaretli; mobil kopya legalTexts.ts (kvkk, terms).
  // Uygulamayla eşitlendi (21.10.2026): saklama = kullanıcı silene/hesabı kapatana kadar (hesap kapanınca kalıcı silme,
  // kanuni yükümlülükler saklı); bildirimlerde kiracı verisi yok; somut teknik önlemler. AVUKATA NOT: anlık bildirim için
  // mevcut KVKK 7.2 yurt dışı aktarım satırına atıf yeterli mi; kiracı verisi için ayrı veri işleme eki (KVKK m.12) gerekir mi.
  // 21.10.2026 — Kiracı portalı (davet, dekont, mesaj) ve kira geliri beyannamesi yardımcısı — AVUKAT İNCELEMESİ GEREKLİ:
  // legal.kvkk (2, 3, 6, 8. bölümlere satır/maddeler; 5. "mulk-takibi" bölümüne veri kategorileri, "Kiracı portalı — kim neyi görür",
  // "Kiracı portalında roller", "Kira geliri beyannamesi yardımcısı" ve güvenlik/bildirim/aktarım/saklama eklemeleri) ve terms
  // (3. "hizmet" paragrafı; 9. "mulk-takibi" bölümüne 4 yeni madde). tr/en.json'da "_review" alanıyla işaretli; mobil kopya
  // legalTexts.ts (kvkk, terms) aynı. Yürürlük tarihi değişmedi (aynı gün). AVUKATA NOT: kiracının ev sahibine ilettiği dekont/mesajlarda
  // rol ayrımı; vergi girdilerinin "kaydedilmez" ifadesinin istek kayıtları (log) açısından backend ile teyidi.
  lastUpdated: '21 Ekim 2026',
  lastUpdatedEn: 'October 21, 2026',
};

/** i18n interpolation değerleri (dil bazlı tarih). */
export const legalValues = (lang) => ({
  ...LEGAL,
  lastUpdated: String(lang || '').startsWith('en') ? LEGAL.lastUpdatedEn : LEGAL.lastUpdated,
});

/** "[...]" biçimindeki doldurulmamış alan mı? */
export const isLegalPlaceholder = (value) => typeof value === 'string' && /^\[.*\]$/.test(value.trim());

/** Yasal sayfalar (footer, ilgili metinler listesi ve rotalar için tek liste). */
export const LEGAL_DOCS = [
  { key: 'kvkk', path: '/kvkk' },
  { key: 'privacy', path: '/privacy' },
  { key: 'cookies', path: '/cookies' },
  { key: 'terms', path: '/terms' },
  { key: 'commercialConsent', path: '/ticari-ileti-onayi' },
  { key: 'explicitConsent', path: '/acik-riza' },
  { key: 'crmAgreement', path: '/crm-sozlesmesi' },
  { key: 'crmNotice', path: '/crm-aydinlatma' },
];
